import { useTranslation } from "react-i18next";
import { Briefcase } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { EMPTY_SELECT_VALUE } from "../../utils/employeeConstants";
import { useCountryConfig } from "../../hooks/useCountryConfig";

const EmployeeJobSection = ({ formData, updateField, departements }) => {
  const { t } = useTranslation();
  const { config } = useCountryConfig();
  const currencyCode = config?.currency?.code ?? "TND";
  const showIsPostier = config?.employee_fields?.show_is_postier !== false;
  return (
    <div className="space-y-4">
      <h3 className="font-medium flex items-center space-x-2">
        <Briefcase className="h-4 w-4" />
        <span>{t("employeesPage.sections.jobAssignment")}</span>
      </h3>
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="poste">{t("employeesPage.labels.jobName")}</Label>
          <Input id="poste" placeholder={t("employeesPage.placeholders.jobName")} value={formData.job_name} onChange={(e) => updateField("job_name", e.target.value)} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="departement_id">{t("employeesPage.labels.department")}</Label>
          <Select value={formData.department_id} onValueChange={(v) => updateField("department_id", v)}>
            <SelectTrigger><SelectValue placeholder={t("employeesPage.placeholders.department")} /></SelectTrigger>
            <SelectContent className="max-h-60 overflow-y-auto">
              {departements.map((dep) => (
                <SelectItem key={dep.id} value={dep.id.toString()}>
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 rounded-full" style={{ backgroundColor: dep.level === 0 ? "#3B82F6" : dep.level === 1 ? "#10B981" : "#F59E0B", marginLeft: `${dep.level * 8}px` }} />
                    <span className={dep.level === 0 ? "font-semibold" : dep.level === 1 ? "font-medium" : "font-normal"}>{dep.name}</span>
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <p className="text-xs text-muted-foreground mt-1">{t("employeesPage.descriptions.departmentHierarchy")}</p>
        </div>
        <div />
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="salaire">{t("employeesPage.labels.salaryBase")} ({currencyCode})</Label>
          <Input id="salaire" type="number" placeholder={t("employeesPage.placeholders.salary")} value={formData.salary} onChange={(e) => updateField("salary", e.target.value)} />
        </div>
        <div />
        <div />
      </div>
      <div className="grid grid-cols-3 gap-4">
        {showIsPostier && (
          <div className="space-y-2">
            <Label>{t("employeesPage.labels.isPostier")}</Label>
            <Select value={formData.is_postier ? "true" : "false"} onValueChange={(v) => updateField("is_postier", v === "true")}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="true">{t("common.yes")}</SelectItem>
                <SelectItem value="false">{t("common.no")}</SelectItem>
              </SelectContent>
            </Select>
          </div>
        )}
        <div className="space-y-2">
          <Label>{t("employeesPage.labels.regime")}</Label>
          <Select value={formData.regime || EMPTY_SELECT_VALUE} onValueChange={(v) => updateField("regime", v === EMPTY_SELECT_VALUE ? "" : v)}>
            <SelectTrigger><SelectValue placeholder={t("employeesPage.placeholders.regime")} /></SelectTrigger>
            <SelectContent>
              <SelectItem value={EMPTY_SELECT_VALUE}>{t("employeesPage.regime.undefined")}</SelectItem>
              <SelectItem value="MENSUEL">{t("employeesPage.regime.monthly")}</SelectItem>
              <SelectItem value="JOURNALIER">{t("employeesPage.regime.daily")}</SelectItem>
              <SelectItem value="HORAIRE">{t("employeesPage.regime.hourly")}</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div />
      </div>
    </div>
  );
};

export default EmployeeJobSection;
